"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _couponPackage = require("@/api/basic/couponPackage");
var _couponExpiry = require("@/utils/couponExpiry");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponItemTab',
  props: {
    filterPackageId: {
      default: null
    },
    filterPackageName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      uploading: false,
      list: [],
      total: 0,
      query: {
        keyword: '',
        crmCouponId: null,
        packageId: null,
        page: 1,
        limit: 20
      },
      currentPackageName: '',
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      imgDialog: {
        visible: false,
        row: null,
        current: ''
      }
    };
  },
  watch: {
    filterPackageId: function filterPackageId(val) {
      this.currentPackageName = this.filterPackageName || (val ? '券包ID: ' + val : '');
      this.query = {
        keyword: '',
        crmCouponId: null,
        packageId: val,
        page: 1,
        limit: 20
      };
      this.fetchList();
    }
  },
  mounted: function mounted() {
    this.fetchList();
  },
  methods: {
    formatYxq: _couponExpiry.formatYxq,
    isCouponValid: function isCouponValid(row) {
      return !(0, _couponExpiry.isCouponConfigExpired)(row);
    },
    clearPackageFilter: function clearPackageFilter() {
      this.currentPackageName = '';
      this.query.packageId = null;
      this.query.page = 1;
      this.fetchList();
    },
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      var params = _objectSpread({}, this.query);
      if (!params.crmCouponId) delete params.crmCouponId;
      if (!params.packageId) delete params.packageId;
      if (!params.keyword) delete params.keyword;
      (0, _couponPackage.getCouponItemPage)(params).then(function (res) {
        _this.list = (res.data.records || []).map(function (r) {
          return _objectSpread(_objectSpread({}, r), {}, {
            _editing: false,
            _alias: r.couponAlias
          });
        });
        _this.total = res.data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.query.page = 1;
      this.fetchList();
    },
    resetSearch: function resetSearch() {
      this.query = {
        keyword: '',
        crmCouponId: null,
        packageId: null,
        page: 1,
        limit: 20
      };
      this.fetchList();
    },
    saveAlias: function saveAlias(row) {
      var _this2 = this;
      (0, _couponPackage.updateCouponAlias)({
        id: row.id,
        couponAlias: row._alias
      }).then(function () {
        row.couponAlias = row._alias;
        row._editing = false;
        _this2.$message.success('保存成功');
      });
    },
    openImgUpload: function openImgUpload(row) {
      this.imgDialog = {
        visible: true,
        row: row,
        current: row.couponImgUrl
      };
    },
    handleImgChange: function handleImgChange(e) {
      var _this3 = this;
      var file = e.target.files[0];
      if (!file) return;
      var fd = new FormData();
      fd.append('file', file);
      fd.append('path', '/couponItem/');
      this.uploading = true;
      (0, _couponPackage.uploadImage)(fd).then(function (res) {
        var url = res.data;
        (0, _couponPackage.updateCouponImg)({
          id: _this3.imgDialog.row.id,
          couponImgUrl: url
        }).then(function () {
          _this3.imgDialog.row.couponImgUrl = url;
          _this3.imgDialog.current = url;
          _this3.$message.success('上传成功');
        });
      }).finally(function () {
        _this3.uploading = false;
        e.target.value = '';
      });
    }
  }
};